<!-- 关于弘知 -->
<template>
  <div
    class="about"
    style="min-width: 1600px;"
  >
    <NavBar
      :navIndex="navIndexs"
      :imgHeight="482"
    ></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <div style="position:relative;width: 100%;">
      <img
        style="width: 100%;"
        src="../assets/photo-album-bg.png"
        alt=""
        class="mod-section-ad"
      >

      <div class="animate__animated animate__mian slogan">
        <div class="slogan-title">多维动态</div>
        <div class="slogan-subtitle">
          有深度、有温度、有态度
        </div>
      </div>
    </div>
    <!-- 选择 -->
    <div style="display: flex;align-items: center;justify-content: center;">
      <div
        v-for="(item,index) in tabData"
        :key="index"
        class="select-tab"
        :class="item.status?'select-tab-true':'select-tab-false'"
        @click="selectContent(item.name,index)"
      >{{item.name}}</div>
    </div>

    <!-- 内容 -->
    <div class="content-big-box">
      <br> <br> <br><br><br>
      <!-- 多彩校区 -->
      <div style="width: 1200px;">
        <div class="subtitle">
          多彩校区
          <div
            class=""
            style="position:absolute;width: 30px;height:2px;background-color: #0050A7;bottom: -25%;"
          ></div>
        </div>

        <div class="show-photo-box">
          <!-- 描点跳转 -->
          <div
            id="多彩校区"
            class="anchorPoint"
          ></div>
          <div
            class="photo-box"
            v-for="(item,index) in campusData"
            :key="index"
          >
            <img
              class="photo-img scaleImg_hover br-r6"
              @click="showBigImg('多彩校区',index)"
              :src="item.pic"
              alt=""
            >
            <div class="photo-text">{{item.picDesc}}</div>
          </div>

          <!-- <div class="photo-box">
                        <img class="photo-img" src="../assets/home-demo.png" alt="">
                        <div class="photo-text">我是一句文案我是一句文案我是一句文案我是一句文案控制在三十字</div>
                    </div> -->

        </div>

        <div class="pagination-block">
          <el-pagination
            @current-change="changepagination_xq"
            layout="prev, pager, next"
            :page-size="8"
            :total="total_xq"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 多趣工作 -->
      <div style="width: 1200px;">

        <!-- 标题 -->
        <div class="subtitle">
          多趣工作
          <div
            class=""
            style="position:absolute;width: 30px;height:2px;background-color: #0050A7;bottom: -25%;"
          ></div>
        </div>

        <div class="show-photo-box">
          <!-- 描点跳转 -->
          <div
            id="多趣工作"
            class="anchorPoint"
          ></div>

          <div
            class="photo-box"
            v-for="(item,index) in workData"
            :key="index"
          >
            <img
              class="photo-img scaleImg_hover br-r6"
              @click="showBigImg('多趣工作',index)"
              :src="item.pic"
              alt=""
            >
            <div class="photo-text">{{item.picDesc}}</div>
          </div>

        </div>

        <div class="pagination-block">
          <el-pagination
            @current-change="changepagination_gz"
            layout="prev, pager, next"
            :page-size="8"
            :total="total_gz"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 多样生活 -->
      <div style="width: 1200px;">
        <div class="subtitle">
          多样生活
          <div
            class=""
            style="position:absolute;width: 30px;height:2px;background-color: #0050A7;bottom: -25%;"
          ></div>
        </div>

        <div class="show-photo-box">
          <!-- 描点跳转 -->
          <div
            id="多样生活"
            class="anchorPoint"
          ></div>
          <div
            class="photo-box"
            v-for="(item,index) in liveData"
            :key="index"
          >
            <img
              class="photo-img scaleImg_hover br-r6"
              @click="showBigImg('多样生活',index)"
              :src="item.pic"
              alt=""
            >
            <div class="photo-text">{{item.picDesc}}</div>
          </div>

        </div>

        <div class="pagination-block">
          <el-pagination
            @current-change="changepagination_sh"
            layout="prev, pager, next"
            :page-size="8"
            :total="total_sh"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 多维动态 -->
      <div style="width: 1200px;">
        <div class="subtitle">
          多维动态
          <div
            class=""
            style="position:absolute;width: 30px;height:2px;background-color: #0050A7;bottom: -25%;"
          ></div>
        </div>

        <div
          style="background-color: #fff;"
          class="show-photo-box"
        >
          <!-- 描点跳转 -->
          <div
            id="多维动态"
            class="anchorPoint"
          ></div>
          <div style="width: 1200px;margin:0 auto;display: flex;flex-wrap: wrap;">
            <!-- 新闻列表单元格 -->
            <div
              v-for="(item,index) in dynamicListData"
              :key="index"
              class="dynamic-list-box"
              @click="goDynamicDetail(item)"
            >
              <div class="dynamic-list-time">
                <div style="color: #999999;">{{item.time}}</div>
                <div class="dynamic-day">{{item.day}}</div>
              </div>

              <div
                class="dynamic-content-box"
                :style="{border:(index === dynamicListData.length - 1)?'none':''}"
              >

                <div style="margin: 0px 50px 0px 0;">
                  <div class="dynamic-content-title">
                    {{item.dynamicName}}
                  </div>
                  <p style="color: #666666;margin-top: 15px;line-height: 28px;-webkit-box-orient: vertical;text-overflow: ellipsis;
                            overflow: hidden;
                            display: -webkit-box;
                            line-clamp: 2; 
                            height: 60px;word-break: break-all;">
                    {{item.dynamicTwo}}
                  </p>
                </div>

                <div class="click-box">
                  <img
                    class="click-img"
                    src="../assets/click-img.png"
                    alt=""
                  >
                  <img
                    class="click-img-null"
                    src="../assets/click-img-null.png"
                    alt=""
                  >
                </div>
              </div>
            </div>

          </div>
          <div class="pagination-block">
            <el-pagination
              @current-change="changepagination"
              layout="prev, pager, next"
              :page-size="6"
              :total="total"
            >
            </el-pagination>
          </div>

        </div>

      </div>

    </div>
    <!-- 弘知相册查看大图 -->
    <div
      v-if="lookBigImg"
      style="display: flex;justify-content: center;align-items: center;position: fixed;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.9);top: 0;left: 0;z-index: 15;"
    >
      <i
        @click="closeImg()"
        class="el-icon-circle-close"
        style="position: absolute;right:80px;top: 120px;color: #fff;font-size: 40px;cursor: pointer;"
      ></i>
      <el-carousel
        :interval="4000"
        :initial-index="carousel_index"
        type="card"
        height="600px"
        style="width: 1200px;"
      >
        <el-carousel-item
          v-for="(item,index) in bigImgData"
          :key="index"
          style="display: flex;align-items: center;justify-content: center;"
        >
          <!-- <img style="width: 100%;" :src="item.pic" alt=""> -->
          <div style="position: relative;width: 600px;height: 480px;">
            <img
              style="display: block;width: 100%;width: 600px;height: 480px;object-fit: cover;"
              :src="item.pic"
              alt=""
            >
            <div class="photo-carousel-text">
              {{item.picDesc}}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <Footer></Footer>
  </div>
</template>
    
    <script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import { homeImg, dynamicList } from "@/request/api";

export default {
  name: "photoAlbum",
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      content_control: "1", // 1为多彩校区，2为多趣工作，3为多样生活
      tabData: [
        { name: "多彩校区", status: true },
        { name: "多趣工作", status: false },
        { name: "多样生活", status: false },
        { name: "多维动态", status: false },
      ],
      navIndexs: "5-1",
      campusData: [],
      workData: [],
      liveData: [], // 多样生活
      total_xq: 1, // 多彩校区总数
      total_gz: 1, // 多彩校区总数
      total_sh: 1, // 多彩校区总数
      lookBigImg: false, // 查看大图控制
      carousel_index: 0,
      page_control: "1",
      jobData: [],
      total: 6,
      jobContent: {}, //工作信息详情
      dynamicListData: [],
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    let type = this.$route.query.type;
    if (type == "多维动态") {
      document.getElementById("多维动态").scrollIntoView()
    }

    let that = this;
    // console.log(this.$route.query)
    let obj = this.$route.query;
    let data = that.tabData;
    data.forEach(function (res, index) {
      if (res.name === obj.type) {
        res.status = true;
      } else {
        res.status = false;
      }
    });
    // console.log("22",data)
    that.tabData = data;

    homeImg("pageSize=8&pageNum=1&type=1").then((res) => {
      console.log("多彩校区", res.data);
      that.campusData = res.data.result;
      that.total_xq = res.data.total;
    });

    homeImg("pageSize=8&pageNum=1&type=2").then((res) => {
      console.log("多趣工作", res.data);
      that.workData = res.data.result;
      that.total_gz = res.data.total;
    });

    homeImg("pageSize=8&pageNum=1&type=3").then((res) => {
      console.log("多样生活", res.data);
      that.liveData = res.data.result;
      that.total_sh = res.data.total;
    });

    dynamicList("pageNum=1&pageSize=6").then((res) => {
      console.log("动态", res.data.result);
      let data = res.data.result;
      data.forEach(function (res, index) {
        res.time = res.insertDate.slice(0, 7);
        res.day = res.insertDate.slice(8, 10);
      });
      that.dynamicListData = data;
      that.total = res.data.total;
      console.log(data);
    });
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    lookJob(e) {
      let that = this;
      that.page_control = "2";
      console.log(e);
      this.jobContent = e;
    },
    showJob() {
      this.page_control = "1";
    },
    goHome() {
      this.$router.push("/");
    },
    changepagination(e) {
      console.log(e);
      let that = this;
      dynamicList("pageSize=6&pageNum=" + e).then((res) => {
        console.log("招聘", res.data.result);
        let data = res.data.result;
        data.forEach(function (res, index) {
          res.time = res.insertDate.slice(0, 7);
          res.day = res.insertDate.slice(8, 10);
        });
        that.dynamicListData = data;
      });
    },
    goDynamicDetail(e) {
      console.log("e", e);
      this.$router.push({
        name: "dynamic_detail",
        query: { dynamicId: e.dynamicId },
      });
    },
    fetchData() {
      // console.log("路由发送变化doing...");
      let that = this;
      // console.log(this.$route.query)
      let obj = this.$route.query;
      let data = that.tabData;
      data.forEach(function (res, index) {
        if (res.name === obj.type) {
          res.status = true;
        } else {
          res.status = false;
        }
      });
      // console.log("22",data)
      that.tabData = data;
      if (obj.type === "多彩校区") {
        that.content_control = "1";
        that.navIndexs = "5-1";
      } else if (obj.type === "多趣工作") {
        that.content_control = "2";
        that.navIndexs = "5-2";
      } else if (obj.type === "多样生活") {
        that.content_control = "3";
        that.navIndexs = "5-3";
      } else if (obj.type === "多维动态") {
        that.content_control = "4";
        that.navIndexs = "5-4";
      }
    },
    selectContent(e, index) {
      console.log(e,'e');
      this.scrollIntoView(e);

      let that = this;

      if (e === "多彩校区") {
        that.content_control = "1";
        that.navIndexs = "5-1";
      } else if (e === "多趣工作") {
        that.content_control = "2";
        that.navIndexs = "5-2";
      } else if (e === "多样生活") {
        that.content_control = "3";
        that.navIndexs = "5-3";
      } else if (e === "多维动态") {
        that.content_control = "4";
        that.navIndexs = "5-4";
      }

      let data = that.tabData;
      data.forEach(function (res, index) {
        res.status = false;
      });
      data[index].status = true;
      // console.log(data)
      that.tabData = data;
    },
    // 多彩校区
    changepagination_xq(e) {
      console.log(e);
      let that = this;
      homeImg("pageSize=8&type=1&pageNum=" + e).then((res) => {
        console.log("多彩校区", res.data);
        that.campusData = res.data.result;
      });
    },
    changepagination_gz(e) {
      let that = this;
      homeImg("pageSize=8&type=2&pageNum=" + e).then((res) => {
        console.log("多趣工作", res.data);
        that.workData = res.data.result;
      });
    },
    changepagination_sh(e) {
      let that = this;
      homeImg("pageSize=8&type=3&pageNum=" + e).then((res) => {
        console.log("多样生活", res.data);
        that.liveData = res.data.result;
      });
    },
    showBigImg(e, index) {
      let that = this;

      if (e === "多彩校区") {
        // 多彩校区
        that.bigImgData = that.campusData;
      } else if (e === "多趣工作") {
        // 多趣工作
        that.bigImgData = that.workData;
      } else if (e === "多样生活") {
        // 多样生活
        that.bigImgData = that.liveData;
      }
      that.carousel_index = index;
      that.lookBigImg = true;
    },
    closeImg() {
      this.lookBigImg = false;
    },
  },
};
</script>
    
    <style scoped>
.content-title-box {
  position: relative;
  font-size: 38px;
  font-weight: bold;
  text-align: center;
}
.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #0050a7;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}

.select-tab {
  width: 200px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  margin: 0 40px;
}
.select-tab-true {
  color: #0053ad;
  font-weight: bold;
}
.select-tab-false {
  color: #333333;
  font-weight: bold;
}
.select-tab:hover {
  color: #0053ad;
}
.content-big-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 70px;
  background-color: #f7f7f7;
  box-sizing: border-box;
}
.content-box {
  display: flex;
  width: 570px;
  background-color: #fff;

  margin: 10px;
}
.content-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}
.content-img {
  flex-shrink: 0;
  width: 210px;
  height: 210px;
  background-color: #ccc;
}
.content-text-box {
  padding: 20px 15px;
}
.content-title {
  font-size: 20px;
  font-weight: bold;
}
.content-text {
  margin-top: 10px;
  line-height: 28px;
  font-size: 14px;
}

.explain-box {
  width: 75%;
  background-color: #fff;
  margin: 20px auto 0;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.explain-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}

/* 相册 */
.show-photo-box {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}
.photo-box {
  width: 280px;
  margin: 10px;
  background-color: #fff;
  cursor: pointer;
}
.photo-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}
.photo-img {
  width: 280px;
  height: 224px;
  object-fit: cover;
}
.photo-text {
  padding: 5px 10px 10px;
  line-height: 28px;
}
.photo-carousel-text {
  position: absolute;
  bottom: 0;
  padding: 15px;
  color: #fff;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  max-height: 80px;
  overflow: hidden;
  line-height: 30px;
  width: 100%;
  box-sizing: border-box;
}

/* 分页 */
.pagination-block {
  text-align: center;
  margin: 30px;
  width: 100%;
}

.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}
.job-cell {
  width: 31%;
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
  margin: 10px;
  cursor: pointer;
}
.job-cell:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}

.teacher-classify {
  position: relative;
  font-size: 26px;
  font-weight: bold;
  width: 70%;
  margin-bottom: 25px;
}
.teacher-classify-border {
  position: absolute;
  width: 32px;
  height: 2px;
  background-color: #0050a7;
  bottom: -25%;
}

/* 动态列表 */
.dynamic-list-box {
  display: flex;
  align-items: center;
}
.dynamic-list-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  text-align: center;
  border: 1px solid #dedede;
  margin-left: 16px;
}
.dynamic-day {
  font-size: 36px;
  color: #0053ad;
  font-weight: bold;
  margin-top: 5px;
}
.dynamic-content-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
  padding: 40px 15px 40px 0;
  margin-left: 30px;
  cursor: pointer;
}
.dynamic-content-title {
  color: #333333;
  font-size: 20px;
  font-weight: bold;
}
.dynamic-content-box:hover .dynamic-content-title {
  color: #0053ad;
}
.click-box {
  width: 40px;
  position: relative;
  min-height: 20px;
  flex-shrink: 0;
}
.click-img {
  width: 40px;
  position: absolute;
  z-index: 1;
}
.click-img-null {
  width: 40px;
  position: absolute;
  z-index: 2;
  background-color: #fff;
}
.dynamic-content-box:hover .click-img {
  z-index: 2;
}
.dynamic-content-box:hover .click-img-null {
  z-index: 1;
}

.subtitle {
  position: relative;
  font-size: 26px;
  font-family: "PingFang-Bold";
}
</style>
        